module.exports = __webpack_public_path__ + "img/banner_top2.c43d5462.png";